import type { Socket } from 'socket.io-client';

// import { io, Socket } from 'socket.io-client';
import { requester } from '@/api/axios';

import { apiConst, keyConst } from '@/constants';

// import { captureApiException } from '@/api/axios';
import {
  ApiResponse,
  ExpertStatusUpdatedPayload,
  MessageData,
  NotificationCountUpdatePayload,
  NotificationSnapshot,
  NotificationUpdatePayload,
} from '@/interface';

export interface ChatResponse {
  currentUser: { currentUserId: string };
  data: MessageData[];
}

export interface RecipientCountItem {
  projectId?: string;
  tenantId?: string;
  count?: number;
}

let unifiedSocket: Socket | null = null;
// let isConnecting = false;
const activeTypingKeys = new Set<string>();

export const connectUnifiedSocket = (token?: string): Promise<Socket> => {
  void token;
  // return new Promise((resolve, reject) => {
  //   if (unifiedSocket && unifiedSocket.connected) {
  //     return resolve(unifiedSocket);
  //   }
  //
  //   if (isConnecting) {
  //     const checkConnection = () => {
  //       if (unifiedSocket && unifiedSocket.connected) {
  //         resolve(unifiedSocket);
  //       } else if (!isConnecting) {
  //         connectUnifiedSocket(token).then(resolve).catch(reject);
  //       } else {
  //         setTimeout(checkConnection, 100);
  //       }
  //     };
  //     setTimeout(checkConnection, 100);
  //     return;
  //   }
  //
  //   if (unifiedSocket && !unifiedSocket.connected) {
  //     unifiedSocket.removeAllListeners();
  //     unifiedSocket = null;
  //   }
  //
  //   isConnecting = true;
  //   const savedToken = token || localStorage.getItem(keyConst.userToken);
  //   unifiedSocket = io(import.meta.env.VITE_BASE_URL, {
  //     auth: { token: savedToken },
  //     transports: ['websocket'],
  //   });
  //
  //   unifiedSocket.on('connect', () => {
  //     isConnecting = false;
  //     resolve(unifiedSocket!);
  //   });
  //
  //   unifiedSocket.on('connect_error', (err: any) => {
  //     isConnecting = false;
  //     captureApiException(err, 'socket.connectUnifiedSocket', {
  //       socketUrl: import.meta.env.VITE_BASE_URL,
  //       hasToken: Boolean(savedToken),
  //     });
  //     console.error('Socket connection error:', err.message);
  //     reject(err);
  //   });
  //
  //   unifiedSocket.on('disconnect', () => {
  //     isConnecting = false;
  //   });
  // });
  unifiedSocket = null;
  return Promise.resolve(null as unknown as Socket);
};

// export const connectSocket = (projectId: string, token?: string): Promise<Socket> => {
//   void projectId;
//   return connectUnifiedSocket(token);
//   // return connectUnifiedSocket(token).then((socket) => {
//   //   socket.emit('joinProjectRoom', { projectId });
//   //   return socket;
//   // });
// };

export const getUnifiedSocket = (): Socket | null => unifiedSocket;

export const sendMessage = (payload: {
  projectId: string;
  content: string;
  replyToMessageId?: string;
  otherUserId?: string;
  attachments?: string[];
}) => {
  // unifiedSocket?.emit(`${apiConst.sendMessage}`, payload);
  return requester({
    method: 'post',
    url: apiConst.unifiedChatProjectMessage,
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
  });
};

export const clientsendMessage = (payload: {
  projectId: string;
  content: string;
  replyToMessageId?: string;
  attachments?: string[];
}) => {
  // unifiedSocket?.emit(`${apiConst.clientsendMessage}`, payload);
  return requester({
    method: 'post',
    url: apiConst.unifiedChatClientProjectMessage,
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
  });
};

// export const disconnectSocket = () => {
//   // if (unifiedSocket) {
//   //   unifiedSocket.disconnect();
//   //   unifiedSocket = null;
//   //   isConnecting = false;
//   // }
//   unifiedSocket = null;
// };
export const emitTyping = (projectId: string, username: string) => {
  const typingKey = `project:${projectId}:${username}`;
  if (activeTypingKeys.has(typingKey)) return;
  activeTypingKeys.add(typingKey);

  // unifiedSocket?.emit('typing', { projectId, username });
  void requester({
    method: 'post',
    url: apiConst.unifiedChatProjectTyping,
    data: { projectId, username },
    headers: { Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}` },
  });
};

export const emitStopTyping = (projectId: string, username: string) => {
  activeTypingKeys.delete(`project:${projectId}:${username}`);
  // unifiedSocket?.emit('stopTyping', { projectId, username });
  void requester({
    method: 'post',
    url: apiConst.unifiedChatProjectStopTyping,
    data: { projectId, username },
    headers: { Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}` },
  });
};

export const getProjectChat = async (projectId: string): Promise<ApiResponse<ChatResponse>> => {
  const config = {
    method: 'get',
    url: `${apiConst.chat}/teamChat/${projectId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
  };
  return await requester(config);
};

export const getClientChat = async (projectId: string, token: string): Promise<ApiResponse<ChatResponse>> => {
  const config = {
    method: 'get',
    url: `${apiConst.clientChat}/${projectId}`,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  return await requester(config);
};

// export const connectPreChatSocket = (token?: string): Promise<Socket> => {
//   return connectUnifiedSocket(token);
// };

export const joinPreChatRoom = (data: { clientId: string; tenantId: string; projectId?: string }) => {
  void data;
  // unifiedSocket?.emit('joinPreChatRoom', data);
};

// export const emitPreChatMessage = (payload: {
//   clientId: string;
//   tenantId: string;
//   projectId?: string;
//   message: string;
//   attachments?: string[];
// }) => {
//   // unifiedSocket?.emit('sendPreChatMessage', payload);
//   return requester({
//     method: 'post',
//     url: apiConst.unifiedChatPreChatMessage,
//     data: payload,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
//       'Content-Type': 'application/json',
//     },
//   });
// };

// export const onPreChatMessageReceived = (callback: (msg: any) => void) => {
//   void callback;
//   // unifiedSocket?.on('receivePreChatMessage', callback);
// };

export const emitPreChatTyping = (clientId: string, tenantId: string, username: string, projectId?: string) => {
  const typingKey = `pre-chat:${clientId}:${tenantId}:${projectId || ''}:${username}`;
  if (activeTypingKeys.has(typingKey)) return;
  activeTypingKeys.add(typingKey);

  // unifiedSocket?.emit('userTyping', { clientId, tenantId, projectId, username });
  void requester({
    method: 'post',
    url: apiConst.unifiedChatPreChatTyping,
    data: { clientId, tenantId, projectId, username },
    headers: { Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}` },
  });
};

export const emitPreChatStopTyping = (clientId: string, tenantId: string, username: string, projectId?: string) => {
  activeTypingKeys.delete(`pre-chat:${clientId}:${tenantId}:${projectId || ''}:${username}`);

  // unifiedSocket?.emit('userStopTyping', { clientId, tenantId, projectId, username });
  void requester({
    method: 'post',
    url: apiConst.unifiedChatPreChatStopTyping,
    data: { clientId, tenantId, projectId, username },
    headers: { Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}` },
  });
};
export const getPreChat = async (clientId: string, token: string) => {
  const config = {
    method: 'get',
    url: `${apiConst.preChat}/${clientId}`,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  return await requester(config);
};

export const getPreChatHistory = async (clientId: string, token: string, tenantId?: string, projectId?: string) => {
  const url = new URL(`${import.meta.env.VITE_BASE_URL}/${apiConst.preChat}/history/${clientId}`);
  if (tenantId) {
    url.searchParams.set('tenantId', tenantId);
  }
  if (projectId) {
    url.searchParams.set('projectId', projectId);
  }

  const config = {
    method: 'get',
    url: url.toString(),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  return await requester(config);
};

export const sendPreChatMessage = async (payload: {
  clientId: string;
  content: string;
  attachments?: string[];
  tenantId?: string;
  projectId?: string;
  replyToMessageId?: string;
}) => {
  const token = localStorage.getItem(keyConst.userToken);

  const decoded = token ? JSON.parse(atob(token.split('.')[1])) : null;

  const transformedPayload = {
    message: payload.content,
    senderId: decoded?.userId,
    clientId: payload.clientId,
    tenantId: payload.tenantId || decoded?.companyId,
    projectId: payload.projectId,
    senderRole: decoded?.userType,
    replyToMessageId: payload.replyToMessageId,
    attachments: payload.attachments,
  };

  const res = await requester({
    method: 'post',
    url: apiConst.unifiedChatPreChatMessage,
    data: transformedPayload,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return res.data;
};

export const transferPreChatToProject = async (projectId: string, clientId: string, companyId?: string, token?: string) => {
  const config = {
    method: 'post',
    url: `${apiConst.preChat}/transfer/${projectId}/${clientId}`,
    data: { companyId },
    headers: {
      Authorization: `Bearer ${token || localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
  };
  return await requester(config);
};

export const getUnseenCount = (data: { clientId: string; tenantId: string; projectId?: string }) => {
  // unifiedSocket?.emit('getUnseenCount', data);
  void requester({
    method: 'post',
    url: apiConst.unifiedChatPreChatUnseenCount,
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}` },
  });
};

export const markMessagesAsSeen = (data: { clientId: string; tenantId: string; projectId?: string }) => {
  // unifiedSocket?.emit('markMessagesAsSeen', data);
  void requester({
    method: 'post',
    url: apiConst.unifiedChatPreChatMarkSeen,
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}` },
  });
};

// export const onUnseenCountUpdate = (
//   callback: (data: { count: number; clientId: string; tenantId: string; projectId?: string }) => void,
// ) => {
//   void callback;
//   // unifiedSocket?.on('unseenCountUpdate', callback);
// };
//
// export const onUnseenCount = (
//   callback: (data: { count: number; clientId: string; tenantId: string; projectId?: string }) => void,
// ) => {
//   void callback;
//   // unifiedSocket?.on('unseenCount', callback);
// };

// export const getPreChatSocket = (): Socket | null => unifiedSocket;

// export const getAllNotifications = async (token: string) => {
//   const config = {
//     method: 'get',
//     url: `${apiConst.preChat}/notifications`,
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//   };
//   return await requester(config);
// };
//
// export const getTotalUnseenCount = async (token: string) => {
//   const config = {
//     method: 'get',
//     url: `${apiConst.preChat}/total-unseen-count`,
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//   };
//   return await requester(config);
// };

export const getProjectChatUnseenCount = (data: { projectId: string }) => {
  // unifiedSocket?.emit('getProjectChatUnseenCount', data);
  void requester({
    method: 'post',
    url: apiConst.unifiedChatProjectUnseenCount,
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}` },
  });
};

export const markProjectChatMessagesAsSeen = (data: { projectId: string }) => {
  // unifiedSocket?.emit('markProjectChatMessagesAsSeen', data);
  void requester({
    method: 'post',
    url: apiConst.unifiedChatProjectMarkSeen,
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}` },
  });
};

// export const onProjectChatUnseenCountUpdate = (
//   callback: (data: { count: number; projectId: string; recipientId: string }) => void,
// ) => {
//   void callback;
//   // unifiedSocket?.on('projectChatUnseenCountUpdate', callback);
// };
//
// export const onProjectChatUnseenCount = (callback: (data: { count: number; projectId: string }) => void) => {
//   void callback;
//   // unifiedSocket?.on('projectChatUnseenCount', callback);
// };

// export const getProjectChatUnseenCountAPI = async (projectId: string, token: string) => {
//   const config = {
//     method: 'get',
//     url: `${apiConst.chat}/unseen-count/${projectId}`,
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//   };
//   return await requester(config);
// };
//
// export const markProjectChatMessagesAsSeenAPI = async (projectId: string, token: string) => {
//   const config = {
//     method: 'post',
//     url: `${apiConst.chat}/mark-seen/${projectId}`,
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//   };
//   return await requester(config);
// };

// export const getProjectChatNotifications = async (token: string) => {
//   const config = {
//     method: 'get',
//     url: `${apiConst.chat}/notifications`,
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//   };
//   return await requester(config);
// };
//
// export const getProjectChatTotalUnseenCount = async (token: string) => {
//   const config = {
//     method: 'get',
//     url: `${apiConst.chat}/total-unseen-count`,
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//   };
//   return await requester(config);
// };

// export const onNotificationUpdate = (
//   callback: (data: { recipientId: string; totalCount: number; notification: any }) => void,
// ) => {
//   unifiedSocket?.on('notificationUpdate', callback);
// };
//
// export const onNotificationCountUpdate = (callback: (data: { recipientId: string; totalCount: number }) => void) => {
//   unifiedSocket?.on('notificationCountUpdate', callback);
// };

export interface SseConnection {
  close: () => void;
}

const connectAuthorizedEventStream = (
  url: string,
  token: string,
  handlers: Record<string, (data: unknown) => void>,
  errorLabel: string,
): SseConnection => {
  const abortController = new AbortController();
  let reconnectTimer: ReturnType<typeof setTimeout> | undefined;
  let closed = false;
  let reconnectAttempts = 0;

  const scheduleReconnect = () => {
    if (closed || abortController.signal.aborted) return;

    const delay = Math.min(3000 * 2 ** reconnectAttempts, 30000);
    reconnectAttempts += 1;
    reconnectTimer = setTimeout(openStream, delay);
  };

  const openStream = async () => {
    try {
      const response = await fetch(url, {
        headers: {
          Accept: 'text/event-stream',
          Authorization: `Bearer ${token}`,
        },
        signal: abortController.signal,
      });

      if (!response.ok || !response.body) {
        if (response.status === 401 || response.status === 403) {
          closed = true;
          console.error(`${errorLabel} SSE authentication failed with status ${response.status}`);
          return;
        }

        throw new Error(`SSE request failed with status ${response.status}`);
      }

      reconnectAttempts = 0;
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let eventName = 'message';
      let dataLines: string[] = [];

      const dispatchEvent = () => {
        if (!dataLines.length) return;

        const handler = handlers[eventName];
        if (handler) {
          try {
            handler(JSON.parse(dataLines.join('\n')));
          } catch (eventError) {
            console.error(`${errorLabel} SSE event handling error:`, eventError);
          }
        }

        eventName = 'message';
        dataLines = [];
      };

      while (!closed) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split(/\r?\n/);
        buffer = lines.pop() || '';

        lines.forEach((line) => {
          if (!line) {
            dispatchEvent();
            return;
          }

          if (line.startsWith('event:')) {
            eventName = line.slice(6).trim();
          } else if (line.startsWith('data:')) {
            dataLines.push(line.slice(5).trimStart());
          }
        });
      }

      if (buffer.trim()) {
        buffer.split(/\r?\n/).forEach((line) => {
          if (!line) {
            dispatchEvent();
            return;
          }

          if (line.startsWith('event:')) {
            eventName = line.slice(6).trim();
          } else if (line.startsWith('data:')) {
            dataLines.push(line.slice(5).trimStart());
          }
        });
      }
      dispatchEvent();

      reader.releaseLock();
      scheduleReconnect();
    } catch (error) {
      if (!closed && !abortController.signal.aborted) {
        console.error(`${errorLabel} SSE error:`, error);
        scheduleReconnect();
      }
    }
  };

  void openStream();

  return {
    close: () => {
      closed = true;
      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
      }
      abortController.abort();
    },
  };
};

export const connectExpertStatusEvents = (
  projectId: string | null,
  token: string,
  onExpertStatusUpdated: (data: ExpertStatusUpdatedPayload) => void,
): SseConnection => {
  const basePath = projectId ? `/expert-status-events/${projectId}` : '/expert-status-events';
  const url = new URL(`${import.meta.env.VITE_BASE_URL}${basePath}`);

  return connectAuthorizedEventStream(
    url.toString(),
    token,
    { expertStatusUpdated: (data) => onExpertStatusUpdated(data as ExpertStatusUpdatedPayload) },
    'Expert status',
  );
};

export const connectNotificationEvents = (
  token: string,
  handlers: {
    onNotificationSnapshot?: (data: NotificationSnapshot) => void;
    onNotificationUpdate?: (data: NotificationUpdatePayload) => void;
    onNotificationCountUpdate?: (data: NotificationCountUpdatePayload) => void;
  },
): SseConnection => {
  const url = new URL(`${import.meta.env.VITE_BASE_URL}/notification-events`);

  return connectAuthorizedEventStream(
    url.toString(),
    token,
    {
      notificationSnapshot: (data) => handlers.onNotificationSnapshot?.(data as NotificationSnapshot),
      notificationUpdate: (data) => handlers.onNotificationUpdate?.(data as NotificationUpdatePayload),
      notificationCountUpdate: (data) => handlers.onNotificationCountUpdate?.(data as NotificationCountUpdatePayload),
    },
    'Notification',
  );
};

export const connectUnifiedProjectEvents = (
  projectId: string,
  token: string,
  handlers: {
    onReceiveMessage?: (data: MessageData) => void;
    onUserTyping?: (data: { username: string }) => void;
    onUserStopTyping?: (data: { username: string }) => void;
    onProjectChatUnseenCount?: (data: NotificationCountUpdatePayload) => void;
    onProjectChatUnseenCountUpdate?: (data: NotificationCountUpdatePayload) => void;
  },
): SseConnection => {
  const url = new URL(`${import.meta.env.VITE_BASE_URL}/unified-events/project/${projectId}`);

  return connectAuthorizedEventStream(
    url.toString(),
    token,
    {
      receiveMessage: (data) => handlers.onReceiveMessage?.(data as MessageData),
      userTyping: (data) => handlers.onUserTyping?.(data as { username: string }),
      userStopTyping: (data) => handlers.onUserStopTyping?.(data as { username: string }),
      projectChatUnseenCount: (data) => handlers.onProjectChatUnseenCount?.(data as NotificationCountUpdatePayload),
      projectChatUnseenCountUpdate: (data) => handlers.onProjectChatUnseenCountUpdate?.(data as NotificationCountUpdatePayload),
    },
    'Unified project',
  );
};

export const connectUnifiedPreChatEvents = (
  data: { clientId: string; tenantId: string; projectId?: string },
  token: string,
  handlers: {
    onReceivePreChatMessage?: (message: MessageData) => void;
    onPreChatHistory?: (history: unknown) => void;
    onUserTyping?: (data: { username: string }) => void;
    onUserStopTyping?: (data: { username: string }) => void;
  },
): SseConnection => {
  const url = new URL(`${import.meta.env.VITE_BASE_URL}/unified-events/pre-chat`);
  url.searchParams.set('clientId', data.clientId);
  url.searchParams.set('tenantId', data.tenantId);
  if (data.projectId) {
    url.searchParams.set('projectId', data.projectId);
  }

  return connectAuthorizedEventStream(
    url.toString(),
    token,
    {
      receivePreChatMessage: (message) => handlers.onReceivePreChatMessage?.(message as MessageData),
      preChatHistory: (history) => handlers.onPreChatHistory?.(history),
      userTyping: (data) => handlers.onUserTyping?.(data as { username: string }),
      userStopTyping: (data) => handlers.onUserStopTyping?.(data as { username: string }),
    },
    'Unified pre-chat',
  );
};

export const connectUnifiedRecipientEvents = (
  token: string,
  handlers: {
    onRecipientCountsSnapshot?: (data: {
      preChatCounts?: RecipientCountItem[];
      projectChatCounts?: RecipientCountItem[];
    }) => void;
    onUnseenCount?: (data: NotificationCountUpdatePayload) => void;
    onUnseenCountUpdate?: (data: NotificationCountUpdatePayload) => void;
    onProjectChatUnseenCount?: (data: NotificationCountUpdatePayload) => void;
    onProjectChatUnseenCountUpdate?: (data: NotificationCountUpdatePayload) => void;
  },
): SseConnection => {
  const url = new URL(`${import.meta.env.VITE_BASE_URL}/unified-events/recipient`);

  return connectAuthorizedEventStream(
    url.toString(),
    token,
    {
      recipientCountsSnapshot: (data) =>
        handlers.onRecipientCountsSnapshot?.(
          data as { preChatCounts?: RecipientCountItem[]; projectChatCounts?: RecipientCountItem[] },
        ),
      unseenCount: (data) => handlers.onUnseenCount?.(data as NotificationCountUpdatePayload),
      unseenCountUpdate: (data) => handlers.onUnseenCountUpdate?.(data as NotificationCountUpdatePayload),
      projectChatUnseenCount: (data) => handlers.onProjectChatUnseenCount?.(data as NotificationCountUpdatePayload),
      projectChatUnseenCountUpdate: (data) => handlers.onProjectChatUnseenCountUpdate?.(data as NotificationCountUpdatePayload),
    },
    'Unified recipient',
  );
};

export const joinProjectRoom = (projectId: string) => {
  void projectId;
  // unifiedSocket?.emit('joinProjectRoom', { projectId });
};

export const leaveProjectRoom = (projectId: string) => {
  void projectId;
  // unifiedSocket?.emit('leaveProjectRoom', { projectId });
};

export const leavePreChatRoom = (data: { clientId: string; tenantId: string; projectId?: string }) => {
  void data;
  // unifiedSocket?.emit('leavePreChatRoom', data);
};
